import { useCallback } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';

import { useHistory } from 'src/lib/hooks/useHistory';
import { ROUTE_PARAMS, ROUTES } from 'src/routes';

export const useNavigateToApplication = () => {
  const history = useHistory();
  const location = useLocation();

  // Navigate to where we should go after successful login
  return useCallback(
    (params) => {
      // If we were redirected from somewhere to SignIn, then go there
      const from = location?.state?.from;
      const disableFrom = location?.state?.disableFrom;
      const options = params?.addFrom ? { state: { from: window.location.pathname } } : null;

      if (from && !disableFrom) {
        history.replace(from, options);
        return;
      }

      if (params?.wasUserCreated) {
        history.replace(
          `${ROUTES.ROOT}${
            location.search
              ? `${location.search}&${ROUTE_PARAMS.userCreated}`
              : `?${ROUTE_PARAMS.userCreated}`
          }`,
          options
        );
        return;
      }

      history.replace(`${ROUTES.ROOT}${location.search}`, options);
    },
    [location, history]
  );
};
